"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var react_dropzone_1 = __importDefault(require("react-dropzone"));
var MAX_UPLOAD_SIZE = 5 * 1024 * 1024;
var ACCEPT_FILE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/pjpeg"];
var DropzoneInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store, children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        store.value && react_1.default.createElement("input", { type: "hidden", name: store.name, value: store.value }),
        react_1.default.createElement(react_dropzone_1.default, { multiple: false, maxSize: MAX_UPLOAD_SIZE, accept: ACCEPT_FILE_TYPES, onDrop: store.handleDrop, onDragEnter: store.handleDragEnter, onDragLeave: store.handleDragLeave, className: store.dropzoneClassNames }, children)));
});
exports.default = DropzoneInput;
